module.exports = __webpack_public_path__ + "img/icon_success@2x.a6f8380f.png";